import React from 'react'
import css from '@styled-system/css'
import styled from 'styled-components'
import { Image, Flex, Subtitle } from 'ui/bend'
import { DownloadFile } from 'images/bend'
import { Desc, H6Title } from './CommonStyles'
import { Badge } from './badge'
import { AlomovesIconSVG } from 'images/latest'
import { ResponsiveSVG } from 'ui/acro'

const Main = styled.div`
  width: 100%;
  .no-image {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f2f2f2;
    aspect-ratio: 16/9;
  }
`

const Download = styled(Flex)(() =>
  css({
    gap: '4px',
    width: 'fit-content'
  })
)

const DownloadCTA = styled(Subtitle)(() =>
  css({
    color: '#000',
    letterSpacing: '0.308px',
    textDecorationLine: 'underline',
    textUnderlinePosition: 'from-font'
  })
)

export const BonusItem = (cardData) => {
  const image = cardData?.item?.image
  return (
    <Main>
      {cardData?.itemTag && <Badge>{cardData?.itemTag}</Badge>}
      {image ? (
        <Image
          src={image}
          objectFit='cover'
          width='100%'
          height='100%'
          style={{
            aspectRatio: '16/9'
          }}
        />
      ) : (
        <div className='no-image'>
          <ResponsiveSVG
            width={['68px', '68px', '130px', '130px']}
            height={['68px', '68px', '130px', '130px']}
            SVG={AlomovesIconSVG}
            className='no-thumbnail'
          />
        </div>
      )}
      <H6Title>{cardData.item.title}</H6Title>
      <Desc>{cardData.description}</Desc>
      <Download
        as={'a'}
        href={cardData.item.file}
        target={'_blank'}
        download='guide.pdf'
      >
        <DownloadCTA>Download</DownloadCTA>
        <DownloadFile />
      </Download>
    </Main>
  )
}
